module.exports = __webpack_public_path__ + "static/media/checkmark-red.39dd4dec.svg";